type ScoreSource = {
  attemptStatus?: string | null;
  scorePercent?: number | null;
  lastAttemptScorePercent?: number | null;
};

export function scorePercentForDisplay(learnerTraining?: ScoreSource | null) {
  if (!learnerTraining) return 0;

  const activeScoreWasReset =
    learnerTraining.scorePercent === 0 &&
    learnerTraining.lastAttemptScorePercent != null;

  if (learnerTraining.attemptStatus === 'failed' || activeScoreWasReset) {
    return (
      learnerTraining.lastAttemptScorePercent ??
      learnerTraining.scorePercent ??
      0
    );
  }

  return learnerTraining.scorePercent ?? 0;
}
